import validationNo from '../resources/no/validation.json';
import validationSe from '../resources/se/validation.json';
import { MessagePaths, useMessagesTranslation } from '@shared/i18n';

const defaultResources = { validation: validationNo };

export type ValidationResouces = typeof defaultResources;

export type ValidationLanguageResources = {
  no: ValidationResouces;
  se: ValidationResouces;
}

export const validationLanguageResourcesResources: ValidationLanguageResources = {
  no: defaultResources,
  se: { validation: validationSe },
};

export type ValidationMessageKeys = MessagePaths<typeof defaultResources>;

export const useValidationTranslation = () => useMessagesTranslation<ValidationResouces>()

export const useValidationTFunction = () => useValidationTranslation().t;

export type ValidationTFunction = ReturnType<typeof useValidationTFunction>;
